"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultiBuildings = exports.isUnique = exports.getName = void 0;
exports.getName = function (record) {
    return [record.name, record.phase, record.block].filter(function (it) { return it; }).join(' / ');
};
exports.isUnique = function (value, index, array) { return array.indexOf(value) === index; };
exports.isMultiBuildings = function (transactions) {
    return transactions.map(function (it) { return exports.getName(it); }).filter(exports.isUnique).length > 1;
};
